import { render } from "./Detail.vue?vue&type=template&id=31285894&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=31285894&lang=scss&scoped=true"

import exportComponent from "/var/www/md_tele_vue/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31285894"]])

export default __exports__